import { LastMessage } from './types/Conversation';
import { MakeCall } from './createMakeCall';

const getLastMessageInConversation = (makeCall: MakeCall) => () =>
  makeCall<LastMessage>('GET', `/api/v2/conversations/last-message`);
export { getLastMessageInConversation };
